// CreateSurvey.jsx
import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";
import InputWithLabel from "../../components/shared/fields/InputWithLabel";
import Button from "../../components/shared/buttons/button";
import { showToast } from "../../helpers/Utils";
import { useCreateSurveyMutation, useUploadImageMetadataMutation } from "../../app/surveyApi/surveyApi";
import QuestionBlock from "./QuestionBlock";
import "./survey.css";
import { useNavigate } from "react-router";
import CommonBreadcrumb from "../../components/shared/breadcrumb/CommonBreadcrumb";
import { useLocation } from "react-router";
import { useGetAllSurveyCategoriesQuery } from "../../app/surveyApi/surveyCategoryApi";
import SelectBox from "../../components/shared/fields/SelectBox";
const CreateSurvey = () => {
  const { state } = useLocation()
  console.log(state, "state-->");
  const cateId = state?.surveyId
  const cateName = state?.cateName
  const { data: surveyCategory } = useGetAllSurveyCategoriesQuery();
  console.log(cateName, "cateName");

  const myCategory = surveyCategory?.data?.data?.find(user => user._id === cateId)
  console.log(myCategory, "myCategory");

  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [questions, setQuestions] = useState([{ text: "", type: "text", isRepeatable: false, isCompulsory: true, imageFile: null , tooltip:"", showCommentBox: false  }]);
  const [surveyImage, setSurveyImage] = useState(null);
  const [pdfImage, setPdfImage] = useState(null)
  const [createSurvey, { isLoading }] = useCreateSurveyMutation();
  const [uploadImageMetadata, { isLoading: isUploadingImages }] = useUploadImageMetadataMutation();
  console.log(questions, "questions");

  const handleQuestionChange = (index, field, value) => {
    const updated = [...questions];
    updated[index][field] = value;

    if (field === "isRepeatable") {
      updated[index].isRepeatable = value;
      updated[index].questionType = value ? "number" : updated[index].questionType;
      if (value && !updated[index].subQuestions) {
        updated[index].subQuestions = [];
      }
      if (!value) {
        delete updated[index].subQuestions;
      }
    }
    if (field === "isCompulsory") {
      updated[index].isCompulsory = value;
    }
    if (field === "tooltip") {
      updated[index].tooltip = value;
    }
    if (field === "showCommentBox") {
      updated[index].showCommentBox = value;
    }
    if (field === "type") {
      if (["singleSelect", "multiSelect"].includes(value)) {
        updated[index].options = updated[index].options || [""];
      } else {
        delete updated[index].options;
      }

      if (value === "range") {
        updated[index].min = 1;
        updated[index].max = 10;
      } else {
        delete updated[index].min;
        delete updated[index].max;
      }

      if (value === "number" && updated[index].isRepeatable) {
        updated[index].subQuestions = updated[index].subQuestions || [];
      }
    }

    setQuestions(updated);
  };

  const handleOptionChange = (qIndex, oIndex, value) => {
    const updated = [...questions];
    updated[qIndex].options[oIndex] = value;
    setQuestions(updated);
  };

  const addOption = (qIndex) => {
    const updated = [...questions];

    // Ensure options array exists
    if (!Array.isArray(updated[qIndex].options)) {
      updated[qIndex].options = [];
    }

    // Check for blank options
    const hasBlankOption = updated[qIndex].options.some(
      (opt) => !opt || !opt.trim()
    );

    if (hasBlankOption) {
      showToast("Option should not be blank.", "error");
      return;
    }

    // Add new option
    updated[qIndex].options.push("");
    setQuestions(updated);
  };

  const removeOption = (qIndex, oIndex) => {
    const updated = [...questions];
    updated[qIndex].options.splice(oIndex, 1);
    setQuestions(updated);
  };

  const handleRangeChange = (index, field, value) => {
    const updated = [...questions];
    updated[index][field] = Number(value);
    setQuestions(updated);
  };

  const handleImageChange = (index, file) => {
    const updated = [...questions];
    updated[index].imageFile = file;
    setQuestions(updated);
  };

  const handleSubQuestionImageChange = (qIndex, subIndex, file) => {
    const updated = [...questions];
    updated[qIndex].subQuestions[subIndex].imageFile = file;
    setQuestions(updated);
  };

  const addQuestion = () => {
    const hasBlankTitle = questions.some((q) => !q.text || !q.text.trim());
    if (hasBlankTitle) {
      showToast("Question title should not be blank.", "error");
      return;
    }
    setQuestions([...questions, { text: "", type: "text", isRepeatable: false, isCompulsory: true, imageFile: null , tooltip:"", showCommentBox: false  }]);
  };

  const removeQuestion = (index) => {
    const updated = [...questions];
    updated.splice(index, 1);
    setQuestions(updated);
  };

  const handleSubQuestionChange = (qIndex, subIndex, field, value) => {
    const updated = [...questions];
    updated[qIndex].subQuestions[subIndex][field] = value;
    setQuestions(updated);
  };

  const addSubQuestion = (qIndex) => {
    const updated = [...questions];

    // Ensure subQuestions array exists
    if (!Array.isArray(updated[qIndex].subQuestions)) {
      updated[qIndex].subQuestions = [];
    }

    // Check for blank subquestion titles
    const hasBlankTitle = updated[qIndex].subQuestions.some(
      (subQ) => !subQ.text || !subQ.text.trim()
    );

    if (hasBlankTitle) {
      showToast("Subquestion title should not be blank.", "error");
      return;
    }

    // Add new subquestion
    updated[qIndex].subQuestions.push({ text: "", type: "text", imageFile: null, showCommentBox: false });
    setQuestions(updated);
  };

  const removeSubQuestion = (qIndex, subIndex) => {
    const updated = [...questions];
    updated[qIndex].subQuestions.splice(subIndex, 1);
    setQuestions(updated);
  };

  const transformQuestion = (q) => {
    const base = {
      text: q.text,
      questionType: q.type,
      isRepeatable: q.isRepeatable || false,
      isCompulsory: q.isCompulsory || false,
      tooltip: q.tooltip,
      showCommentBox: q.showCommentBox || false
    };

    if (q.imageUrl) {
      base.imageUrl = q.imageUrl;
    }

    if (["singleSelect", "multiSelect"].includes(q.type)) {
      base.options = q.options?.filter((opt) => opt.trim() !== "").map((opt) => ({
        value: opt.toLowerCase().replace(/\s+/g, "-"),
        label: opt,
      }));
    }

    if (q.type === "range") {
      base.min = q.min ?? 1;
      base.max = q.max ?? 10;
    }

    if (q.subQuestions) {
      base.subQuestions = q.subQuestions.map(transformQuestion);
    }

    return base;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim()) {
      showToast("Survey title should not be blank.", "error");
      return;
    }
    if (!description.trim()) {
      showToast("Survey description should not be blank.", "error");
      return;
    }

    try {
      let updatedQuestions = [...questions];

      // Step 1: Collect all images (main questions and subquestions)
      const allImages = [];
      const imageMapping = [];

      questions.forEach((q, qIndex) => {
        if (q.imageFile) {
          allImages.push(q.imageFile);
          imageMapping.push({ type: 'main', qIndex });
        }
        
        if (q.subQuestions && Array.isArray(q.subQuestions)) {
          q.subQuestions.forEach((subQ, subIndex) => {
            if (subQ.imageFile) {
              allImages.push(subQ.imageFile);
              imageMapping.push({ type: 'sub', qIndex, subIndex });
            }
          });
        }
      });
      
      if (allImages.length > 0) {
        showToast("Uploading question images...", "info");
        
        const imageFormData = new FormData();
        allImages.forEach((imageFile, idx) => {
          imageFormData.append(`image${idx + 1}`, imageFile);
        });

        const imageUploadResponse = await uploadImageMetadata({ body: imageFormData }).unwrap();
        
        if (imageUploadResponse.type === "success") {
          showToast("Images uploaded successfully!", "success");
          
          // Step 2: Map uploaded image URLs to corresponding questions and subquestions
          const imageUrls = imageUploadResponse.data.images;
          
          updatedQuestions = questions.map((q, qIndex) => {
            let updatedQ = { ...q };
            
            // Handle main question images
            const mainImageIndex = imageMapping.findIndex(
              mapping => mapping.type === 'main' && mapping.qIndex === qIndex
            );
            if (mainImageIndex !== -1) {
              const imageKey = `image${mainImageIndex + 1}`;
              updatedQ.imageUrl = imageUrls[imageKey];
            }
            
            // Handle subquestion images
            if (updatedQ.subQuestions && Array.isArray(updatedQ.subQuestions)) {
              updatedQ.subQuestions = updatedQ.subQuestions.map((subQ, subIndex) => {
                const subImageIndex = imageMapping.findIndex(
                  mapping => mapping.type === 'sub' && 
                            mapping.qIndex === qIndex && 
                            mapping.subIndex === subIndex
                );
                if (subImageIndex !== -1) {
                  const imageKey = `image${subImageIndex + 1}`;
                  return { ...subQ, imageUrl: imageUrls[imageKey] };
                }
                return subQ;
              });
            }
            
            return updatedQ;
          });
        } else {
          showToast("Failed to upload images", "error");
          return;
        }
      }

      // Step 3: Create survey with transformed questions including image URLs
      const formData = new FormData();
      formData.append("title", title);
      formData.append("survey_category_id", cateId);
      formData.append("description", description);

      const cleanedQuestions = updatedQuestions.map(transformQuestion);
      formData.append("questions", JSON.stringify(cleanedQuestions));

      if (surveyImage) {
        formData.append("survey_image", surveyImage);
      }

      if(pdfImage) {
        formData.append("pdf", pdfImage)
      }

      await createSurvey(formData).unwrap();
      showToast("Survey created successfully!", "success");
      
      // Reset form
      setTitle("");
      setDescription("");
      setSurveyImage(null);
      setPdfImage(null);
      setQuestions([{ text: "", type: "text", isRepeatable: false, isCompulsory: true, imageFile: null , tooltip:"", showCommentBox: false }]);
      navigate(`/survey-category/survey/${cateId}`);
      
    } catch (err) {
      console.log(err);
      showToast(err?.data?.message || "Failed to create survey", "error");
    }
  };

  const breadcrumbItems = [
    { label: "Survey category", path: "/" },
    { label: "Survey", path: `/survey-category/survey/${cateId}` },
    { label: "Create Survey" },
  ];

  return (
    <Row className="my-4">
      <Col lg={12}>
        <CommonBreadcrumb items={breadcrumbItems} />
      </Col>
      <Col lg={8} className="m-auto">
        <h2 className="cmn_title">Create Survey</h2>
        <Form onSubmit={handleSubmit} encType="multipart/form-data">
          <InputWithLabel
            label="Survey Title"
            placeholder="Enter survey title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <SelectBox
            label="Survey Category"
            value={cateId}
            disabled
            options={[{ label: cateName, value: cateId }]}
          />
          <Form.Group className="mb-3">
            <Form.Label>Survey Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Add PDF file for survey</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => setPdfImage(e.target.files[0])}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Survey Image</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => setSurveyImage(e.target.files[0])}
            />
          </Form.Group>

          <div className="d-flex gap-3 justify-content-between">
            <h4 className="quetion-title">Questions</h4>
          </div>

          <div className="d-flex gap-2 flex-column">
            {questions.map((q, index) => (
              <QuestionBlock
                key={index}
                q={q}
                index={index}
                handleQuestionChange={handleQuestionChange}
                handleOptionChange={handleOptionChange}
                addOption={addOption}
                removeOption={removeOption}
                handleRangeChange={handleRangeChange}
                removeQuestion={removeQuestion}
                questionsLength={questions.length}
                handleSubQuestionChange={handleSubQuestionChange}
                addSubQuestion={addSubQuestion}
                removeSubQuestion={removeSubQuestion}
                handleImageChange={handleImageChange}
                handleSubQuestionImageChange={handleSubQuestionImageChange}
              />
            ))}
          </div>

          <div className="d-flex justify-content-end mt-3 addButton">
            <Button
              onClick={addQuestion}
              size="medium"
              label="Add Question"
              className="borderedBtn"
              type="button"
            />

          </div>
          <div className="d-flex justify-content-center pt-5">

            <Button
              size="medium"
              type="submit"
              label={isLoading || isUploadingImages ? "Submitting..." : "Submit Survey"}
              disabled={isLoading || isUploadingImages}
            />
          </div>
        </Form>
      </Col>
    </Row>
  );
};

export default CreateSurvey;